import { Component, Input } from '@angular/core';
import { NotificationType } from '@lib/fresco';
@Component({
    selector: 'dgx-confirm-move-pathway-modal',
    templateUrl: './confirm-move-pathway-modal.component.html',
    styleUrls: ['./confirm-move-pathway-modal.component.scss'],
    standalone: false
})
export class ConfirmMovePathwayModalComponent {
  @Input() hasHostedContent: boolean = false;

  public readonly NotificationType = NotificationType;
}
